import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-user-agent-dialog',
  templateUrl: './user-agent-dialog.component.html',
  styleUrls: ['./user-agent-dialog.component.css']
})
export class UserAgentDialogComponent implements OnInit {

  alertType: string;
  message: string;
  title: string;

  constructor(public dialogRef: MatDialogRef<UserAgentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.alertType = this.data.alertType;
    this.message = this.data.message;
    this.title = this.data.title;
  }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/user-agent-dialog/user-agent-dialog.component.ts